// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { postSubmitAccountCreationForm } from "@store/Framework/Services/Components/AccountCreation/AccountCreationService";

type SubmitContactFormParameter = {} & HasOnSuccess;

export interface SubmitAccountCreationFormApiParameter extends ApiParameter {
    legalName?: string;
    doingBusinessAs?: string;
    individualName: string;
    contactInformation: string;
    phone: string;
    email: string;
    additionalInformation?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitAccountCreationFormApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().store.components.accountCreationForm;
    props.apiParameter = {
        legalName: state.fieldValues["legalName"] ? state.fieldValues["legalName"] : " ",
        doingBusinessAs: state.fieldValues["doingBusinessAs"] ? state.fieldValues["doingBusinessAs"] : " ",
        individualName: state.fieldValues["individualName"]!,
        contactInformation: state.fieldValues["contactInformation"]!,
        phone: state.fieldValues["phone"]!,
        email: state.fieldValues["email"]!,
        additionalInformation: state.fieldValues["additionalInformation"],
    };
};

export const SendDataToApi: HandlerType = async props => {
    await postSubmitAccountCreationForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitAccountCreationForm = createHandlerChainRunner(chain, "SubmitAccountCreationForm");
export default submitAccountCreationForm;
